import AccountingApi from "api/accountingService";
import AccountingChartsData from 'Config/authenticated/AccountingChartsData';
import { persistAccountingChart, sortCodes, sortCodesVat } from "utils/accountingCodes"

export default {
    namespaced: true,
    state(){
        return {
            labels: {},
            codes: [
                {code: "thirds", value: null, type: "third"},
                {code: "staffs", value: null, type: "third"},
                {code: "suppliers", value: null, type: "third"},
                {code: "banks", value: null, type: "bank"},
                {code: "pay_mediums", value: null, type: "bank"},
                {code: "products_sales", value: null, type: "sell"},
                {code: "services_sales", value: null, type: "sell"},
                {code: "sell_discount_code_id", value: null, type: "sell"},
                {code: "collected_vat", value: null, type: "collectionVat"},
                {code: "deductible_vat", value: null, type: "collectionVat"},
                {code: "collected_vat", value: null, type: "debitVat"},
                {code: "deductible_vat", value: null, type: "debitVat"},
                {code: "products_purchases", value: null, type: "purchase"},
                {code: "services_purchases", value: null, type: "purchase"},
                {code: "purchase_discount_code_id", value: null, type: "purchase"},
                {code: "commissions", value: null, type: "reconciliation"},
            ],
            list: {
                third: [],
                bank: [],
                sell: [],
                purchase: [],
                reconciliation: [],
                vat: [],
            },
            codeLength: "",
            depositCode: "",
            discountEnable: true,
        }
    },
    getters: {
        getLabels: (state) => {
            return state.labels;
        },
        getRules: (state) => {
            return state.rules;
        },
        getCode: (state) => (params) => {
            return state.codes?.find(codes => (codes.type === params.type && codes.code === params.code)) || null;
        },
        getCodes: (state) => {
            return state.codes;
        },
        getCodesList: (state) => (type) =>{
            //exception for vat
            type = type?.search(/Vat/) > -1 ? "vat" : type;
            return state.list[type];
        },
        getCodeLength: (state) => {
            return state.codeLength;
        },
        getDepositCode: (state) => {
            return state.depositCode;
        },
        getDiscountEnable: (state) => {
            return state.discountEnable;
        }
    },
    mutations: {
        /**
         * If index of code is defined to set new code value else, search the correct object
         * witch the same code from all codes objects.
         * @param {*} state 
         * @param {*} params 
         */
        setCode: (state, params) => {
            let accountingCode = state.codes?.find(codes => (codes.type === params.type && codes.code === params.code));

            //exception for vat
            params.type = params?.type.search(/Vat/) > -1 ? "vat" : params.type;

            if(!!accountingCode){
                accountingCode.value = state.list[params.type][params.index] ?? state.list[params.type][0];
            }
        },
        setCodeLength: (state, payload) => {
            state.codeLength = !_.isUndefined(payload) ? payload : 0;
        },
        setDepositCode: (state, payload) => {
            state.depositCode = !_.isUndefined(payload) ? payload : 0;
        },
        setDiscountEnable: (state, payload) => {
            state.discountEnable = payload;
        },
        setAccountingChartsLabels: (state) => {
            state.labels = {...AccountingChartsData};
        },
        setCodesList: (state, payload) => {
            state.list.third = payload.filter(code => code.views.includes('third'));
            state.list.purchase = payload.filter(code => code.views.includes('purchase'));
            state.list.sell = payload.filter(code => code.views.includes('sell'));
            state.list.bank = payload.filter(code => code.views.includes('bank'));
            state.list.reconciliation = payload.filter(code => code.views.includes('reconciliation'));
        },
        setVatList: (state, payload) => {
            state.list.vat = payload;
        },
        setUserDefaultCodes: (state, payload) => {
            const codes = state.codes;
            const list = state.list;
            let newCodes = [];

            state.codeLength = (typeof payload.accounting_code_length !== "string") ? 
                payload.accounting_code_length.toString() : payload.accounting_code_length;
            state.depositCode = payload.deposit_accounting_code ?? "";


            // DEFAULT CODE
            newCodes = sortCodes(codes, list, payload.default_codes);

            // VAT
            newCodes = sortCodesVat(newCodes, list, payload.default_codes.collection_vat, "collectionVat");
            newCodes = sortCodesVat(newCodes, list, payload.default_codes.debit_vat, "debitVat");

            // DISCOUNT
            newCodes = sortCodes(newCodes, list, payload.discount);
            state.discountEnable = payload.discount?.enabled ?? true;

            // COMISSION
            let index = newCodes.findIndex(newCode => newCode.code === "commissions");
            newCodes[index].value = list.reconciliation.find(list => list.id === payload.default_codes.commissions);
            state.codes = newCodes;
        }
    },
    actions: {
        updateValue({state, commit, dispatch}, payload){
            try{
                commit(`set${payload.path}`, payload.value);
            }finally{
                dispatch("updateSettingsAccountingCharts", state);
            }
        },
        updateCode({state, commit, dispatch}, payload){
            try{
                commit("setCode", payload);
            }finally{
                dispatch("updateSettingsAccountingCharts", state);
            }
        },
        updateSettingsAccountingCharts: ({state}) => {
            return new Promise((resolve, reject) => {
                const data = persistAccountingChart(state);
                AccountingApi.putSettingsAccountingCharts({}, data).then(response => {
                    resolve();
                }).catch((error) => {
                    reject(error);
                })
            })
        },

        async fetchAccountingCodes({commit, dispatch}){
            const codes = await AccountingApi.getListAccountingCodes()
            commit("setCodesList", codes);
            return codes;
        },

        createVatList: ({commit}, data) => {
            let vat = [];
            if(!_.isNil(data.codes)){
                data.codes.forEach(accountingCode => {
                    //If FR then vat codes start by 455 else it's only starting by 22
                    const match = data.lang === 'fr' ? /^445[0-9]+$/ : /^22[0-9]+$/;
                    if (accountingCode.code.match(match)) {
                        vat.push(accountingCode);
                    }
                })
            }
            commit("setVatList", vat);
        },

        fetchUserAccountingCodes: ({commit}) => {
            return new Promise((resolve, reject) => {
                AccountingApi.getSettingsAccountingCodes().then((res) => {
                   commit("setUserDefaultCodes", res.data);
                   resolve();
                }).catch((err) => {
                   reject(err);
                })
            })
        }

        
    }
}